import React, {useMemo, Fragment} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {
  setFeaturesGroupAvailableFilters,
  toggleFeaturesFiltersVisible
} from "../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import useGetAllFiltersGroups from "../../FeatureCreator/FeaturesFilters/useGetAllFiltersGroups";
import {getAvailableFiltersForFeatures} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";
import PricingFiltersSearchInput from "./PricingFiltersSearchInput";
import PricingFiltersFilterItem from "./PricingFiltersFilterItem";
import {getAuthSubDomain} from "../../../constants/fabricatorHardcode";


const PricingFiltersBody = (props) => {

  const {allFilterGroups, pricingFeaturesReceived, pricingFeaturesList, groupName, theme, auth, asCustomer} = props;

  useGetAllFiltersGroups(allFilterGroups);

  const renderFilterGroups = useMemo(() => {
    if (!groupName || !allFilterGroups.length || !pricingFeaturesReceived || !pricingFeaturesList.length) {
      return []
    }
    const subDomain = getAuthSubDomain(auth, asCustomer);
    return getAvailableFiltersForFeatures(pricingFeaturesList, allFilterGroups, subDomain);
  }, [groupName, pricingFeaturesReceived, allFilterGroups]);

  if (!groupName) {
    return <div className="p-1 pt-2 color-textgray">No Feature Group Selected</div>
  }

  if (!allFilterGroups.length || !pricingFeaturesReceived) {
    return <div className="ui-loader ui-loader--medium"/>
  }

  return (
    <Fragment>
      <PricingFiltersSearchInput theme={theme}/>
      <ul className="fix-ul">
        {renderFilterGroups.map(filterGroup => {
          return <PricingFiltersFilterItem key={filterGroup.id}
                                           filterGroup={filterGroup}/>
        })}
      </ul>
    </Fragment>
  )
};

PricingFiltersBody.propTypes = {
  groupName: PropTypes.string.isRequired,
  theme: PropTypes.string,
}

const mapStateToProps = (store) => {
  const {allFilterGroups, filtersReceived} = store.featuresFiltersState;
  const {auth, asCustomer} = store;

  const {pricingFeaturesList, pricingFeaturesReceived} = store.pricingState;

  return {
    pricingFeaturesReceived,
    pricingFeaturesList,
    filtersReceived,
    allFilterGroups,
  };
};

const mapDispatchToProps = {
  toggleFeaturesFiltersVisible,
  setFeaturesGroupAvailableFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFiltersBody);
